import { TabList, Tabs, Tab, TabPanel } from "@certn/cascadia-react";
import { useTranslation, Trans } from "react-i18next";
import { Route, Routes, useLocation, useResolvedPath } from "react-router-dom";

import { usePermissions } from "../../../components/permissions/PermissionsProvider";
import { AtsIntegrationList } from "../../ats-integrations/AtsIntegrationList";
import { APIKeyList } from "./api-keys/List";
import { Documentation } from "./documentation/Documentation";
import { WebhookList } from "./webhooks/List";

export function APIConfiguration() {
  const { t } = useTranslation();

  const { pathname } = useLocation();
  const url = useResolvedPath("").pathname;
  const { hasPermission } = usePermissions();

  const webhooksUrl = `${url}/webhooks`;
  const documentationUrl = `${url}/documentation`;
  const atsIntegrationsUrl = `${url}/ats-integrations`;

  return (
    <Tabs gap="space-4" selectedKey={pathname} testID="api-configuration-tabs">
      <TabList aria-label={t("Integration settings")}>
        {hasPermission({
          action: "configure",
          target: "ats_integration",
          scope: "all",
        }) && (
          <Tab
            id={atsIntegrationsUrl}
            href={atsIntegrationsUrl}
            testID="ats-integrations-tab"
          >
            <Trans>ATS Integrations</Trans>
          </Tab>
        )}

        <Tab id={url} href={url} testID="api-keys-tab">
          <Trans>API Keys</Trans>
        </Tab>
        <Tab id={webhooksUrl} href={webhooksUrl} testID="webhooks-tab">
          <Trans>Webhooks</Trans>
        </Tab>
        <Tab
          id={documentationUrl}
          href={documentationUrl}
          testID="documentation-tab"
        >
          <Trans>Documentation</Trans>
        </Tab>
      </TabList>
      <TabPanel id={pathname}>
        <Routes>
          <Route path="" element={<APIKeyList />} />
          <Route path="/webhooks" element={<WebhookList />} />
          <Route path="/documentation/*" element={<Documentation />} />
          <Route path="/ats-integrations/*" element={<AtsIntegrationList />} />
        </Routes>
      </TabPanel>
    </Tabs>
  );
}
